var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPorkFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.974,
    height: 71.974,
    viewBox: "0 0 71.974 71.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.409 -16.789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9,54.649l-7.516,9.015a7.486,7.486,0,1,0-5.979,11.977,7.5,7.5,0,1,0,11.977-5.979L42.4,62.146",
    transform: "translate(0 4.124)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9,18.289c-6.877,0-13.495,4.5-16.493,9s-7.5,23.991-7.5,23.991l-4.5,6,4.5,1.5v4.5h4.5l1.606,4.5,5.891-4.5s19.493-4.5,23.991-7.5,9-9.617,9-16.494A20.992,20.992,0,0,0,59.9,18.289Z",
    transform: "translate(1.986 0)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.672,37.142a13.636,13.636,0,0,1-2,6.685",
    transform: "translate(6.212 2.139)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorkFree);
export default __webpack_public_path__ + "static/media/pork_free.7d82055c.svg";
export { ForwardRef as ReactComponent };